import { useQuery } from '@tanstack/react-query';
import {
  baseTypeForExportAction,
  bulkExportTypeForAction,
  type ProgramAction,
} from '../program-actions-menu';
import { useBulkDocumentExport } from './use-bulk-document-export';
import { programExportAvailabilityQueryOptions } from './program-export-availability';
import { useExportProgramBase } from './use-export-program-base';
import type { ProgramBaseType } from './program-export-availability';

/**
 * EU-654 — wiring compartilhado da seção "Extrair bases" do header do editor
 * (as 3 etapas montam o mesmo `ProgramEditShell`): disponibilidade vinda do
 * backend (RN-02/03) + disparo com o toast de 3 estados. `handleExportAction`
 * devolve `true` quando consumiu a ação (os handlers dos containers fazem
 * early-return).
 */
export function useProgramExportMenu(programId: string): {
  exportTypes: ProgramBaseType[] | undefined;
  handleExportAction: (action: ProgramAction) => boolean;
} {
  const exportBase = useExportProgramBase();
  const bulkExport = useBulkDocumentExport();
  const availability = useQuery(programExportAvailabilityQueryOptions(programId));

  function handleExportAction(action: ProgramAction): boolean {
    const type = baseTypeForExportAction(action);
    if (type) {
      exportBase.mutate({ programId, type });
      return true;
    }
    // DEV-498 — as duas opções em massa aparecem onde a lista do backend é
    // renderizada; o comportamento é o mesmo dos dois pontos de acesso.
    const bulkType = bulkExportTypeForAction(action);
    if (!bulkType) return false;
    bulkExport.mutate({ programId, type: bulkType });
    return true;
  }

  return { exportTypes: availability.data, handleExportAction };
}
